// API utility functions for consistent API URL handling
export const getApiUrl = () => {
  // For production on cPanel server, use the same domain with /api prefix
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin + '/api';
  }
  // For development, use environment variable or localhost with /api prefix
  return process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
};

export const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (user.token) {
    headers['Authorization'] = `Bearer ${user.token}`;
  }
  
  // Note: X-Company header is no longer needed
  // Company is automatically detected from user's email domain in the backend
  // Keeping for backward compatibility only (will be ignored if user is authenticated)
  
  return headers;
};

export const apiRequest = async (endpoint, options = {}) => {
  const url = `${getApiUrl()}${endpoint}`;
  
  // Add auth headers if not already present
  if (!options.headers) {
    options.headers = getAuthHeaders();
  } else if (!options.headers['Authorization']) {
    options.headers = { ...options.headers, ...getAuthHeaders() };
  }
  
  try {
    const response = await fetch(url, options);
    
    // If we get a network error or CORS error, provide better error message
    if (!response.ok && response.status === 0) {
      throw new Error(`Cannot connect to backend server at ${getApiUrl()}. Make sure the backend is running on port 5000.`);
    }
    
    return response;
  } catch (error) {
    // Provide more helpful error messages
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      throw new Error(`Cannot connect to backend server. Please check:\n1. Backend server is running (http://localhost:5000)\n2. CORS is configured correctly\n3. No firewall blocking the connection\n\nOriginal error: ${error.message}`);
    }
    throw error;
  }
};
